const headerToolbar = {
    left: 'prev,next today',
    center: '',
    right: 'title'
}

export { headerToolbar }